const isServer = typeof window === 'undefined';

// 延迟导入 localStorageUtil，避免服务端报错
let localStorageUtil: any = null;
if (!isServer) {
  try {
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    localStorageUtil = require('$/common/utils/localStorageUtil').default;
  } catch {
    // 忽略导入错误
  }
}

/**
 * 判断当前浏览器是否支持 webp（仅客户端调用）
 */
function checkWebPSupport() {
  if (isServer) return false;
  try {
    return document
      .createElement('canvas')
      .toDataURL('image/webp')
      .startsWith('data:image/webp');
  } catch {
    return false;
  }
}

/**
 * 获取是否支持 webp（带缓存）
 */
function getWebPSupportStatus() {
  // 服务端默认支持 webp
  if (isServer) return true;

  if (!localStorageUtil) return false;

  try {
    const cached = localStorageUtil.getItem('isSupportWebp');
    if (cached !== null) return cached === 'true';

    const support = checkWebPSupport();
    localStorageUtil.setItem('isSupportWebp', support.toString());
    return support;
  } catch {
    return false;
  }
}

function myImageLoader({
  src,
  width,
  quality,
}: {
  src: string;
  width: number;
  quality?: number;
}) {
  const DOMAIN_WHITELIST = ['meitudata.com', 'pre.roboneo.com'];
  const isDev = process.env.NEXT_PUBLIC_ENV === 'development';

  const isTarget = DOMAIN_WHITELIST.some((domain) => src.includes(domain));
  const hasQuery = src.includes('?');
  // 检查是否已被任一云处理函数处理过（imageMogr2 或 imageView2）
  const hasBeenOptimized = src.includes('imageMogr2') || src.includes('imageView2');

  // 开发环境 & 非目标域名，仅拼接宽度
  if (isDev && !isTarget) {
    return `${src}${hasQuery ? '&' : '?'}width=${width}`;
  }

  // 非目标域名不处理
  if (!isTarget) return src;

  // 已处理过的图片不再重复处理
  if (hasBeenOptimized) return src;

  // svg gif 不处理
  if (src.includes('.svg') || src.includes('.gif')) return src;

  // 宽度存在才处理
  if (width) {
    const effectiveWidth = Math.ceil(width);

    const WEBP = getWebPSupportStatus() ? '/format/webp' : '';
    const ORIENT = '/auto-orient';
    const IGNORE_ERROR = '/ignore-error/1';

    return `${src}${hasQuery ? '&' : '?'}imageMogr2/thumbnail/${effectiveWidth}x${WEBP}${ORIENT}${IGNORE_ERROR}`;
  }

  return src;
}

export default myImageLoader;
